/**
 * Const with params element
 * Social Share component
 * Display social share button
 */
/* Import section */
import PropTypes from "prop-types"
import React from "react"
import { FaFacebookF } from "react-icons/fa"
import { FaTwitter } from "react-icons/fa"
import { FaLinkedinIn } from "react-icons/fa"
import { FiMail } from "react-icons/fi"
import { FacebookShareButton, TwitterShareButton, LinkedinShareButton, EmailShareButton} from "react-share"
import "../styles/components/socialshare.scss"

/* Declaration function */
const Socialshare = ({  urlArticle, titleArticle, leadArticle, topBanner }) => {
  var classEmail = (topBanner === "topbanner") ? 'email-topbanner':'email'
  return (
    <div className="social-share">
      <div className="box-share-button">
        <FacebookShareButton url={urlArticle} quote={leadArticle} >
          <span className="icon">
            <FaFacebookF />
          </span>
        </FacebookShareButton>

        <TwitterShareButton url={urlArticle} title={titleArticle} >
          <span className="icon">
            <FaTwitter />
          </span>
        </TwitterShareButton>

        <LinkedinShareButton url={urlArticle} title={titleArticle} summary={leadArticle} >
          <span className="icon">
            <FaLinkedinIn />
          </span>
        </LinkedinShareButton>

        <EmailShareButton url={urlArticle} subject={titleArticle} >
          <span className={`icon ${classEmail}`}>
            <FiMail />
          </span>
        </EmailShareButton>
      </div>
    </div>
  )
}

/* Function propTypes declaration */
Socialshare.propTypes = {
  urlArticle: PropTypes.string,
  leadArticle: PropTypes.string,
}

/* Export function */
export default Socialshare
